import React from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {approveIncomingRealTimePayment, IncomingRealTimePayment} from "../../resources/incomingRealTimePayment"

interface ApproveIncomingRtpModalProps {
	incomingRtp: IncomingRealTimePayment
	close: () => void
	onSuccess: () => void
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function ApproveIncomingRtpModal({incomingRtp, close, onSuccess}: ApproveIncomingRtpModalProps) {
	const accessToken = useAccessToken()
	const [state, approve] = useAsyncResultIdle(approveIncomingRealTimePayment)

	const instructionId = incomingRtp.attributes.instructionId
	const idempotencyKey = `approve-${incomingRtp.id}`
	return (
		<AsyncResultModal
			title="Approve Incoming Payment"
			close={refreshAndClose(onSuccess, close)}
			buttonClassname="is-success"
			state={state}
			buttonText="Approve"
			successText="Approved"
			onSubmit={() => approve(accessToken, incomingRtp.id, instructionId, idempotencyKey)}
			errorToText={(err) => err.errors[0].title}
		>
			Are you sure you want to approve this incoming payment?
		</AsyncResultModal>
	)
}
